import React from "react";
import Text from "theme/Text";
import i18n from "utils/i18n";
import { textStyles } from "styles/text";
import { View } from "react-native";
import Form from "components/molecules/Form";
import { FormFieldsConstants } from 'utils/constants/form-constants';
import { dataConstants } from "services/redux/data/constants";
import { useSelector } from "react-redux";
import ThemedBlock from "components/atoms/ThemedBlock";
import EmployeeValues from 'scenes/home/more/_functions/Employee'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const ErTab = ({ onUpdate }) => {
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	
	const onChange = ( values ) => {
		EmployeeValues.onChangeEmployee( values )
		onUpdate( values )
	}
	
	const data = {
		response_employee: EmployeeValues.getEmployeeField( _employee, 'response_employee', 'no' ),
	}
	
	const formFields = [
		{
			name: 'response_employee',
			label: i18n.t('form.fields.response_employee.title'),
			type: FormFieldsConstants.SELECT_ACTIVE,
		},
	];
	
	return (
		<VStack
			space={ ThemedValues.stackSpace }>
			
			<ThemedBlock
				mediumPadding
				shadow>
				
				<Text
					style={ textStyles.textCenter }>
					
					{ i18n.t('page.profile.ero.introduction') }
				</Text>
			</ThemedBlock>
			
			<ThemedBlock
				mediumPadding
				shadow>
				
				<View>
					<Form
						values={ data }
						fields={ formFields }
						onChange={ onChange }
						hideSubmit={ true }
					/>
				</View>
			</ThemedBlock>
		</VStack>
	)
}

export default ErTab
